class LayoutsStore {
    set layout(_layout) {
        this._layout = Object.assign({}, _layout);
    }
    get layout() {
        return this._layout;
    }
}
export default new LayoutsStore();
//# sourceMappingURL=layoutsStore.js.map